const FILE_LIKE_PATTERN =
  /((?!\.well-known(?:\/.*)?)(?:[^/]+\/)*[^/]+\.\w+)/;

export function needsTrailingSlash(pathname: string): boolean {
  return (
    pathname.startsWith("/") &&
    !pathname.endsWith("/") &&
    !FILE_LIKE_PATTERN.test(pathname)
  );
}

export function withTrailingSlash(pathname: string): string {
  return needsTrailingSlash(pathname) ? `${pathname}/` : pathname;
}

export function normalizeInternalUrl(target: string): string {
  if (!target.startsWith("/") || target.startsWith("//")) {
    return target;
  }

  const separatorIndex = target.search(/[?#]/);

  if (separatorIndex === -1) {
    return withTrailingSlash(target);
  }

  const pathname = target.slice(0, separatorIndex);
  const rest = target.slice(separatorIndex);

  return `${withTrailingSlash(pathname)}${rest}`;
}
